export enum RoleEnum {
  ASSISTANT = 'assistant',
  USER = 'user',
  SYSTEM = 'system',
}